import { render, staticRenderFns } from "./DiscoveryTableSingleEdit.vue?vue&type=template&id=de9617ec&"
import script from "./DiscoveryTableSingleEdit.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableSingleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports